export const getVideoFirstFrameSrc = (src) => {
  return `${src}#t=0.1`;
};
